// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const postFilterPreference = (userID, filterPreference, contextConfiguration) => axios.post(
	'/zoekopdrachten',
	{
		user: userID,
		...filterPreference
	},
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default postFilterPreference;
